import React from 'react';
import { Link } from 'gatsby';
import styled from 'styled-components';
import { faGithub, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { rem } from 'polished';
import { Button } from '../../components/Button';

interface IPersonSocial {
  githubPortfolio: string;
  linkedInPortfolio: string;
}

export const StyledPersonSocial = styled.div`
  .social {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    flex-wrap: nowrap;
  }
  .social__item {
    display: flex;
    margin-right: 12px;
    button {
      width ${rem(`32px`)};
      padding: 0;
    }
    .body3 {
      flex: 1 0 auto;
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 26px;
    }
  }
`;

export const PersonSocial = ({
  githubPortfolio,
  linkedInPortfolio,
}: IPersonSocial) => (
  <StyledPersonSocial>
    <div className="social">
      <div className="social__item">
        <Link target="_blank" to={githubPortfolio}>
          <Button size="small" disabled={false}>
            <FontAwesomeIcon size="sm" className="link__icon" icon={faGithub} />
          </Button>
        </Link>
      </div>
      <div className="social__item">
        <Link target="_blank" to={linkedInPortfolio}>
          <Button size="small" disabled={false}>
            <FontAwesomeIcon
              size="sm"
              className="link__icon"
              icon={faLinkedinIn}
            />
          </Button>
        </Link>
      </div>
    </div>
  </StyledPersonSocial>
);
